import type { VoicePreset } from '@/shared/types/integration';

/** Selectable presets in display order. Labels are i18n keys. */
export const VOICE_PRESET_OPTIONS: { id: VoicePreset; labelKey: string }[] = [
  { id: 'en', labelKey: 'integrations.voice_common.configuration.preset_en' },
  { id: 'el', labelKey: 'integrations.voice_common.configuration.preset_el' },
  { id: 'pt-br', labelKey: 'integrations.voice_common.configuration.preset_pt_br' },
  { id: 'custom', labelKey: 'integrations.voice_common.configuration.preset_custom' },
];

/** Language presets (everything except 'custom'). */
export type LanguagePreset = Exclude<VoicePreset, 'custom'>;

export const isLanguagePreset = (preset: VoicePreset): preset is LanguagePreset =>
  preset !== 'custom';

/**
 * `config.*` field-name fragments rendered in the collapsed Advanced Settings section.
 * The header uses it to detect validation errors hidden behind the collapsed section.
 */
export const ADVANCED_VOICE_FIELDS = ['stt_', 'tts_', 'thinking_sound'] as const;

/** `config.*` field-name fragments a preset can own, including those rendered in Preferences. */
export const PRESET_VOICE_FIELDS = [...ADVANCED_VOICE_FIELDS, 'denoiser', 'amd'] as const;
